import Permissions, { usePermissions } from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import { insertIf } from '@app/src/utils/helpersTs'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuWrapperProps } from './MenuWrapper'
import MenuWrapper from './MenuWrapper'

const SustainabilityReportMenu: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()
  const { insightReport, supplyChainDueDiligenceStatement } = useFlags()
  const { hasPermission } = usePermissions()

  const permission = Permissions.SUSTAINABILITY_REPORT_ACCESS

  const isAllowed = hasPermission(permission)
  if (!isAllowed) return null

  const menuItems: MenuWrapperProps['menuItems'] = [
    ...insertIf(insightReport, {
      title: formatMessage({ id: 'navbar.insightsReport' }),
      link: navigationLinks.insightsReport,
      permission: [permission],
    }),
    ...insertIf(supplyChainDueDiligenceStatement, {
      title: formatMessage({ id: 'navbar.supplyChainDueDiligenceStatement' }),
      link: navigationLinks.supplyChainDueDiligenceStatement,
      permission: [permission],
    }),
  ]

  if (menuItems.length === 0) return null

  return <MenuWrapper icon={icon} menuItems={menuItems} title={formatMessage({ id: 'navbar.sustainabilityReport' })} />
}

export default SustainabilityReportMenu
